import { render } from "./VideoWall.vue?vue&type=template&id=1364d0d0&ts=true"
import script from "./VideoWall.vue?vue&type=script&lang=ts"
export * from "./VideoWall.vue?vue&type=script&lang=ts"

import "./VideoWall.vue?vue&type=style&index=0&id=1364d0d0&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__